export default import.meta.ROLLUP_FILE_URL_ou9q$qILl9gyDO1LSl$s5Q